angular.injector(['ng', 'translate']).invoke([  'translationLoader',  function (translationLoader) {    translationLoader.addTranslationPartial({
  "DASHBOARD": {
    "ERRORS": {
      "REQUIRED": "This field is required",
      "IBAN": "Invalid IBAN",
      "SWIFT": "Invalid SWIFT/BIC code"
    }
  }
}
);  }]);


//////////////////
// WEBPACK FOOTER
// ./webpack_loaders/nls.js!./app/src/components/translations/dashboard.json
// module id = 430
// module chunks = 24